import { createFileRoute, Navigate } from "@tanstack/react-router"

import { useStepsRouting } from "@/hooks/useStepsRouting"

export const Route = createFileRoute("/$sessionId/_session/")({
  component: IndexRoute,
})

function IndexRoute() {
  const { sessionId } = Route.useParams()

  const { firstUnfinishedStepLink } = useStepsRouting(sessionId)

  if (firstUnfinishedStepLink) {
    return <Navigate {...firstUnfinishedStepLink} />
  }

  return null
}
